import React, { useEffect, useState } from "react";
import { Modal, TextField, Autocomplete } from "@mui/material";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";

const REGEX_CORREO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Modal de envío de cotización por correo — mismo patrón que CatalogoServicioModal (Modal MUI +
// PlantillaScreen). Se abre tras elegir la plantilla del PDF (ver CotizacionesServicioTabla).
// Un solo destinatario por envío — Autocomplete freeSolo con los correos ya registrados del
// cliente (Clientes/GetCorreosCliente), pero permite escribir cualquier otro correo libremente.
// Conectado a CotizacionesCRM/EnviarPDFCorreo (folio, plantilla, destinatarios[], mensaje).
export const ModalEnviarCorreoCotizacion = ({ open, folio, plantilla, idcliente, onClose }) => {
  const [destinatario, setDestinatario] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [correosCliente, setCorreosCliente] = useState([]);
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });

  useEffect(() => {
    if (!open) return;
    setDestinatario("");
    setMensaje("");
    setCorreosCliente([]);

    if (!idcliente) return;
    request
      .get(`CotizacionesCRM/GetCorreosCliente?idcliente=${idcliente}`)
      .then((result) => setCorreosCliente(Array.isArray(result) ? result : []))
      .catch(() => setCorreosCliente([]));
  }, [open, idcliente]);

  const handleEnviar = () => {
    if (!destinatario || !REGEX_CORREO.test(destinatario)) {
      Swal.fire("COTIZACIONES DE SERVICIO", "Favor de capturar un correo válido", "warning");
      return;
    }

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .post("CotizacionesCRM/EnviarPDFCorreo", { folio, plantilla, destinatarios: [destinatario], mensaje })
      .then(() => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("COTIZACIONES DE SERVICIO", "Cotización enviada correctamente", "success").then(() => {
          onClose();
        });
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        const mensajeError = error?.Mensaje || error?.response?.data || "No se pudo enviar la cotización por correo.";
        Swal.fire("COTIZACIONES DE SERVICIO", mensajeError, "error");
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="crmcs-catalogo-modal">
        <LoaderScreen loader={loader} />
        <div className="crmcs-catalogo-modal-close" onClick={onClose}>X</div>
        <PlantillaScreen
          titulo="ENVIAR COTIZACIÓN POR CORREO"
          className_main={1}
          className="crmcs-catalogo-modal-plantilla"
        >
          <div className="crmcs-catalogo-modal-body">
            <Autocomplete
              size="small"
              freeSolo
              options={correosCliente}
              getOptionLabel={(o) => (typeof o === "string" ? o : o.valor || "")}
              value={destinatario}
              onChange={(_, v) => setDestinatario(typeof v === "string" ? v : v?.valor || "")}
              onInputChange={(_, v) => setDestinatario(v || "")}
              renderOption={(props, option) => (
                <li {...props} key={`${option.idcliente}-${option.orden}`}>
                  {option.valor}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Destinatario" placeholder="correo@ejemplo.com" />
              )}
              fullWidth
            />
            <TextField
              size="small"
              label="Mensaje (opcional)"
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              multiline
              minRows={2}
              fullWidth
            />
          </div>

          <div className="crmcs-catalogo-modal-buttons">
            <button className="crmcs-btn-agregar" onClick={handleEnviar}>Enviar</button>
          </div>
        </PlantillaScreen>
      </div>
    </Modal>
  );
};
